import { jsx as _jsx } from "react/jsx-runtime";
/* eslint-disable react/jsx-no-constructed-context-values */
import { createContext, useContext, useState } from 'react';
import { NotificationVariant } from '../../enums/notification';
export const SnackbarContext = createContext({});
export const useSnackbarContext = () => {
    return useContext(SnackbarContext);
};
export const SnackbarContextProvider = ({ children, }) => {
    const [message, setMessage] = useState('');
    const [a11yText, setA11yText] = useState('');
    const [currentVariant, setCurrentVariant] = useState(NotificationVariant.Error);
    const [isOpen, setIsOpen] = useState(false);
    const closeSnackbar = () => {
        setIsOpen(false);
    };
    const openSnackbar = ({ a11yTextCloseButton, content, variant, }) => {
        setMessage(content);
        setA11yText(a11yTextCloseButton);
        setIsOpen(true);
        setCurrentVariant(variant);
    };
    return (_jsx(SnackbarContext.Provider, { value: {
            message,
            a11yText,
            isOpen,
            variant: currentVariant,
            openSnackbar,
            onClose: closeSnackbar,
        }, children: children }));
};
